module.exports = __webpack_public_path__ + "img/config.c116c90f.svg";